import React from "react";
import html2canvas from "html2canvas";

import ImageAd160 from "./imageAd_160";
import ImageAd300 from "./imageAd_300";
import ImageAd728 from "./imageAd_728";

const imgSrc = require("../../../images/950x350-ucla-blue-solid-color-background.jpg");

const ImageAd = ({ parentId, adSize, previewObject }) => {
  //TODO: abstract if conditions !!;
  if (previewObject.headline === "") previewObject.headline = "Headline";
  if (previewObject.description === "")
    previewObject.description = "Description";
  if (previewObject.businessName === "")
    previewObject.businessName = "Business Name";
  if (!previewObject.selectedImage.hasOwnProperty("url"))
    previewObject.selectedImage.url = imgSrc;
  if (!previewObject.selectedLogo.hasOwnProperty("url"))
    previewObject.selectedLogo.url = "";

  const download = (parentId, adElement, imageElement, logoElement) => {
    var parentElement = document.getElementById(parentId);
    html2canvas(parentElement.querySelector(`#${adElement.id}`), {
      scale: 1,
      profile: true,
      useCORS: true,
      allowTaint: true,
      letterRendering: true,
      onrendered: function(canvas) {
        var ctx = canvas.getContext("2d");
        ctx.webkitImageSmoothingEnabled = false;
        ctx.mozImageSmoothingEnabled = false;
        ctx.imageSmoothingEnabled = false;
      },
      onclone: function(document) {
        const adContainer = document
          .getElementById(parentId)
          .querySelector(`#${adElement.id}`);
        if (adElement.backgroundColor) {
          adContainer.querySelector("section").style.backgroundColor =
            adElement.backgroundColor;
        }
        adContainer.querySelector("section").style.width = adElement.width;
        adContainer.querySelector("section").style.marginLeft =
          adElement.sectionMarginLeft || "0px";
        adContainer.style.marginTop = adElement.marginTop;
        adContainer.style.marginLeft = adElement.marginLeft;
        if (imageElement) {
          const image = adContainer.querySelector(imageElement.className);
          image.style.width = imageElement.width;
          image.style.marginTop = imageElement.marginTop;
          image.style.marginLeft = imageElement.marginLeft;
        }
        if (logoElement) {
          const logo = adContainer.querySelector(logoElement.className);
          logo.style.width = logoElement.width;
          logo.style.heigh = logoElement.heigh;
        }
      }
    }).then(canvas => {
      const a = document.createElement("a");
      a.href = canvas
        .toDataURL("image/jpeg")
        .replace("image/jpeg", "image/octet-stream");
      a.download = "banner.jpg";
      a.click();
    });
  };

  if (adSize.width === 160) {
    return (
      <ImageAd160
        parentId={parentId}
        previewObject={previewObject}
        download={download}
      />
    );
  } else if (adSize.width === 728) {
    return (
      <ImageAd728
        parentId={parentId}
        previewObject={previewObject}
        download={download}
      />
    );
  } else if (adSize.width === 300) {
    return (
      <ImageAd300
        parentId={parentId}
        previewObject={previewObject}
        download={download}
      />
    );
  }
};

ImageAd.defaultProps = {
  previewObject: {
    headline: "Headline",
    description: "description"
  }
};

export default ImageAd;
